import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { services, slideVariants } from './servicesData';
import {
  ServicesContainer,
  SectionHeader,
  SectionTitle,
  ServiceCounter,
  CounterText,
  CounterDivider,
} from './ServicesStyles';
import { DesktopLayout, MobileLayout, ServiceTabsComponent } from './ServiceComponents';

const ServicesSection = () => {
  const [ref] = useScrollAnimation({ threshold: 0.2 });
  const [selected, setSelected] = useState(0);
  const [direction, setDirection] = useState(0);

  const currentService = services[selected];

  const handlePrev = () => {
    if (selected > 0) {
      setDirection(-1);
      setSelected(selected - 1);
    }
  };

  const handleNext = () => {
    if (selected < services.length - 1) {
      setDirection(1);
      setSelected(selected + 1);
    }
  };

  return (
    <ServicesContainer id="services" ref={ref}>
      {/* Section Header */}
      <SectionHeader>
          <SectionTitle>SERVICES</SectionTitle>
          <ServiceCounter>
            <CounterText active>{String(selected + 1).padStart(2, '0')}</CounterText>
            <CounterDivider />
            <CounterText>{String(services.length).padStart(2, '0')}</CounterText>
        </ServiceCounter>
      </SectionHeader>

      {/* Desktop Layout (1200px以上) */}
      <Box
        sx={{
          display: { xs: 'none', lg: 'block' },
          width: '100%',
          position: 'relative',
        }}
      >
        <DesktopLayout 
          currentService={currentService}
          services={services}
          selected={selected}
          onSelect={setSelected}
        />
      </Box>

      {/* Mobile & Tablet Layout (1200px未満) */}
      <MobileLayout
        currentService={currentService}
        selected={selected}
        services={services}
        handlePrev={handlePrev}
        handleNext={handleNext}
        direction={direction}
        slideVariants={slideVariants}
      />
    </ServicesContainer>
  );
};

export default ServicesSection;

